<template>
  <div>
    <el-dialog
      :title="'查看绑定网元'"
      :visible="bindNEVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="65%">
      <div v-for="item in tableData">
        <div style="margin-bottom: 5px;">
          <el-tag effect="dark">{{item.businessName}}</el-tag>
          <el-tag style="margin-left: 5px;" effect="plain">{{item.name}}</el-tag>
        </div>
        <el-table
          :data="item.bindList"
          style="width: 100%;margin-bottom: 10px;">
          <el-table-column align="center" prop="area" label="区域" width="80"></el-table-column>
          <el-table-column align="center" prop="instanceId" label="实例ID" width="80"></el-table-column>
          <el-table-column align="center" label="地址">
            <template v-slot="{row}">
              {{row.ip}}:{{row.port}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="serviceName" label="服务名"></el-table-column>
          <el-table-column align="center" prop="room" label="IDC"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {Loading} from "element-ui";

  export default {
    name: "BindNetElement",
    props: {
      bindNEVisible: {
        type: Boolean
      },
      groupObject: {
        type: Object
      }
    },
    data() {
      return {
        tableData: [],
        moduleTypeList: []
      }
    },
    created() {
      this.initNetList();

    },
    methods: {
      handleClose(done) {
        this.$emit('editCallback', false)
        done();
      },
      initNetList() {
        let _this = this;
        _this.moduleTypeList = []
        this.$axios.get(this.baseUrl3 + 'management3/config/generatebusinesstype')
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.moduleTypeList = data.BusinessTypeInfo;
              _this.initData()

            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      initData() {
        let data = {
          "projectSourceId": this.groupObject.groupuuid
        };
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          background: 'rgba(55, 55, 55, 0.4)'
        });
        let _this = this;
        _this.tableData = []
        this.$axios.post(this.baseUrl3 + 'management3/source/getManagement2CheckedSource', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              let businessTypeMap = new Map();
              for (let i = 0; i < _this.moduleTypeList.length; i++) {
                if (_this.moduleTypeList[i].BusinessType == 1) {
                  businessTypeMap.set("1", "聚合")
                } else if (_this.moduleTypeList[i].BusinessType == 2) {
                  businessTypeMap.set("2", "会议")
                }
              }
              for (var keyv in data) {
                let valueArray = data[keyv]
                let BusinessName = "";
                let taskTypeMap = new Map();
                if (valueArray && valueArray.length > 0) {
                  valueArray.forEach( e =>{
                    if(taskTypeMap.get(e.taskType)){
                      let objArray = taskTypeMap.get(e.taskType);
                      objArray.push(e)
                      taskTypeMap.set(e.taskType,objArray)
                    }else {
                      let objArray = []
                      objArray.push(e)
                      taskTypeMap.set(e.taskType,objArray)
                    }
                  })

                  //BusinessName = map.get(valueArray[0].taskType)
                }
                taskTypeMap.forEach(function (value, key, map) {
                  _this.tableData.push({
                    businessName: businessTypeMap.get(key),
                    name: keyv,
                    bindList: value
                  })
                })

              }
              loading.close();
            } else {
              loading.close();
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }

          })
          .catch(err => {
            loading.close();
          })
      }
    }
  }
</script>

<style>
  .el-loading-spinner {
    background-image: url('../../../assets/loading1.svg');
    background-size: 63px 100px;
    background-repeat: no-repeat;
    height: 30%;
    background-position: center;
    top: 200px;
  }

  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }
</style>
